import {
  ReconnectingSocket,
  TUpdateAttributeTopic,
  TUpdateAttributePayload,
  TProcessCommandPayload,
} from "./ReconnectingSocket";

type TCallback = (payload: TUpdateAttributePayload) => void;

export class SocketClient {
  private socket: ReconnectingSocket;
  private subscribers: Record<TUpdateAttributeTopic, TCallback[]> = {
    update_attribute: [],
  };

  constructor() {
    this.socket = new ReconnectingSocket();
  }

  connect() {
    this.socket.connect(this.broadcastCallback.bind(this));
  }

  disconnect() {
    this.socket.disconnect();
  }

  subscribe(callback: TCallback, topic: TUpdateAttributeTopic) {
    this.subscribers[topic].push(callback);
  }

  unsubscribe(callback: TCallback, topic: TUpdateAttributeTopic) {
    this.subscribers[topic] = this.subscribers[topic].filter(
      (c) => c !== callback,
    );
  }

  update_attribute(payload: TUpdateAttributePayload) {
    this.socket.update_attribute(payload);
  }

  process_command(payload: TProcessCommandPayload) {
    this.socket.process_command(payload);
  }

  private broadcastCallback(
    topic: TUpdateAttributeTopic,
    payload: TUpdateAttributePayload,
  ) {
    this.subscribers[topic].forEach((callback) => {
      callback(payload);
    });
  }
}
